import React, { useState, useEffect, useCallback } from 'react';
import Pagination from '@mui/material/Pagination';
// import { useLocation } from 'react-router-dom';
import CreateOrganization from '../../components/CreateOrganization';
import useApi from '../../api/useApi';
import { orgTypes } from '../../Constants';
import Notification from '../../components/Notification';
import '../../scrollbar.css';

function Table() {
  // const location = useLocation();
  const [openCreate, setOpenCreate] = useState(false);
  const [selectedProject, selectProject] = useState({ id: '', name: '' });
  const [{ isLoading, isError, data }, getData] = useApi();
  const [projectData, setProjectData] = useApi();
  const [organizations, setOrganizations] = useState([]);
  const [state, deleteOrg] = useApi();
  const [action, setAction] = useState('');
  const [onClose, setOnClose] = useState(false);
  const [notification, setNotification] = useState(false);
  const [type, setType] = useState(null);
  const [message, setMessage] = useState(null);
  const [formData, setFormData] = useState({ q: '', status: '' });
  const [filteredData, setFilteredData] = useState([]);
  const handleInputChange = useCallback((e) => setFormData({ ...formData, [e.target.name]: e.target.value }));
  const user = localStorage.getItem('user');
  const day = 1000 * 60 * 60 * 24;
  let itemsPerPage;
  if (window.screen.height <= 768) itemsPerPage = 10;
  else if (window.screen.height > 768 && window.screen.height <= 980) itemsPerPage = 12;
  else if (window.screen.height > 980 && window.screen.height <= 1080) itemsPerPage = 15;
  else if (window.screen.height > 1080 && window.screen.height <= 1440) itemsPerPage = 18;
  else if (window.screen.height > 1440 && window.screen.height <= 1800) itemsPerPage = 21;
  else if (window.screen.height > 1800 && window.screen.height <= 2160) itemsPerPage = 24;
  else if (window.screen.height > 2160) itemsPerPage = 27;
  const [pageCount, setpageCount] = useState(0);
  const [page, setPage] = useState(1);
  const [searchFlag, setSearchFlag] = useState(false);
  const handleChange = (event, value) => {
    setPage(value);
  };
  if (!user) {
    location.href = '/';
  }
  const orgId = user && JSON.parse(localStorage.user).organization.id;

  useEffect(() => {
    user && getData(`/organization/${orgId}/projects?limit=${itemsPerPage}&page=${page}`, 'GET');
  }, []);

  useEffect(() => {
    user && getData(`/organization/${orgId}/projects?limit=${itemsPerPage}&page=${page}`, 'GET');
  }, [page]);


  useEffect(() => {
    if (!isLoading && !isError && data) {
      const _projects = data.projects.sort((a, b) =>
        a.projectName.toLowerCase() > b.projectName.toLowerCase() ? 1 : -1
      );
      setFilteredData(_projects);
      let z = _projects;
      if (formData.status) {
        z = z.filter((x) => x?.isActive.toString() === formData.status);
      }
      if (z.length > 0) setOrganizations(z);
      else setOrganizations([]);

      if (page === 1) {
        const total = Math.ceil(data.count / itemsPerPage);
        setpageCount(total);
      }
    }
    if (isError) {
      setType('error');
      setMessage('Unable to fetch Organization Projects');
      setNotification(!notification);
    }
  }, [isLoading, isError, data]);

  const toggleOpenCreate = () => {
    setOpenCreate((prev) => !prev);
  };

  const createNotification = (types, messages) => {
    setType(types);
    setMessage(messages);
    setNotification(!notification);
  };

  const getOrgType = (orgCode) => {
    const x = orgTypes.filter((org) => org.id == orgCode);
    return x[0].value;
  };

  const handleDelete = () => {
    deleteOrg(`/project/${selectedProject.id}`, 'DELETE');
  };

  useEffect(() => {
    if (!state.isLoading && !state.isError && state.data) {
      getData(`/organization/${orgId}/projects?limit=${itemsPerPage}&page=${page}`, 'GET');
      setType('delete');
      setOnClose(false);
      setMessage('Project deleted successfully');
      setNotification(!notification);
    }

    if (state.isError) {
      setType('error');
      setMessage('Unable to delete project');
      setNotification(!notification);
    }
  }, [state]);

  useEffect(() => {
    if (filteredData.length <= 0) {
      return;
    }

    let z = filteredData;
    if (formData.status === '') {
      setOrganizations(filteredData);
    }
    if (formData.status) {
      z = z.filter((x) => x?.isActive.toString() === formData.status);
    }
    if (z.length > 0) setOrganizations(z);
    else setOrganizations([]);
  }, [formData.status]);

  const refreshList = () => {
    getData(`/organization/${orgId}/projects?limit=${itemsPerPage}&page=${page}`, 'GET');
  };

  const alertMsg = (msg) => {
    setNotification(msg);
  };

  const getTimeoffset = (ts) => {
    const _date = new Date(ts);
    const timeZoneOffset = _date.getTimezoneOffset();
    const _timestamp = _date.getTime() - timeZoneOffset * 60 * 1000;
    if (Math.round((Date.now() - new Date(_timestamp).getTime()) / day) !== 0) {
      return `${Math.round((Date.now() - new Date(_timestamp).getTime()) / day)} days ago`;
    }

    if (parseInt(Math.abs(Date.now() - new Date(_timestamp).getTime()) / 36e5) !== 0) {
      return `${parseInt(Math.abs(Date.now() - new Date(_timestamp).getTime()) / 36e5)} hours ago`;
    }

    if (Math.round(((Date.now() - (new Date(_timestamp).getTime() % 86400000)) % 3600000) / 60000) !== 0) {
      return `${Math.round(
        ((Date.now() - (new Date(_timestamp).getTime() % 86400000)) % 3600000) / 60000
      )} minutes ago`;
    }

    return `${parseInt(Math.abs(Date.now() - new Date(_timestamp).getTime()) / 1000)} seconds ago`;

    // Math.round(((diffMs % 86400000) % 3600000) / 60000);
  };

  useEffect(() => {
    if (!projectData.isLoading && !projectData.isError && projectData.data) {
      const rows = [];
      const headerRows = ['PROJECT', 'SHORT NAME', 'SOURCE', 'DESTINATION', 'STATUS', 'LAST MODIFIED'];
      rows.push(headerRows);

      // iterate through rows of table
      for (let i = 0, row; (row = projectData.data.projects[i]); i++) {
        // rows would be accessed using the "row" variable assigned in the for loop
        // Get each cell value/column from the row
        const column1 = row.projectName;
        const column2 = row.shortName;
        const column3 = `${row?.sourceAddress?.city}-${row?.sourceAddress?.country}`;
        const column4 = `${row?.destinationAddress?.city}-${row?.destinationAddress?.country}`;
        const column5 = row?.isActive ? 'ACTIVE' : 'INACTIVE';
        const column6 = getTimeoffset(row?.destinationAddress?.updatedAt);

        /* add a new records in the array */
        rows.push([column1, column2, column3, column4, column5, column6]);
      }
      let csvContent = 'data:text/csv;charset=utf-8,';

      /* add the column delimiter as comma(,) and each row splitted by new line character (\n) */
      rows.forEach(function (rowArray) {
        const row = rowArray.join(',');
        csvContent += `${row}\r\n`;
      });

      /* create a hidden <a> DOM node and set its download attribute */
      const encodedUri = encodeURI(csvContent);
      const link = document.createElement('a');
      link.setAttribute('href', encodedUri);
      link.setAttribute('download', 'Project_Report.csv');
      document.body.appendChild(link);
      /* download the data file named "Stock_Price_Report.csv" */
      link.click();
    }
  }, [projectData]);

  const downloadExcel = (tableID, filename = '') => {
    /* Get the HTML data using Element by Id */
    setProjectData(`/organization/${orgId}/projects`, 'GET');
  };

  const searchData = () => {
    setSearchFlag(true);
    getData(`/search?type=project&searchItem=${formData.q}`, 'GET');
  };

  useEffect(() => {
    if (formData.q === '') {
      setSearchFlag(false);
      setPage(1);
      // getData(`/organization/${orgId}/projects?limit=${itemsPerPage}&page=1`, 'GET');
    }
  }, [formData.q]);

  return (
    <>
      {notification && <Notification type={type} message={message} alertMsg={alertMsg} />}
      {onClose && (
        <div
          className="flex justify-center items-center h-full w-full fixed z-20"
          style={{ background: 'linear-gradient(rgba(0, 0, 0, 0.5),   rgba(0, 0, 0, 0.5))' }}
        >
          <div className="bg-white w-3/12 px-2 text-sm block m-auto rounded-2xl relative">
            <span className="block p-4 font-bold border-b text-textBlue1">Delete Project</span>
            <img
              src="assets/img/Close.svg"
              className="absolute top-3 right-3 h-3 cursor-pointer"
              alt=""
              onClick={() => setOnClose(false)}
            />
            <span className="block text-center text-sm my-8" style={{ color: '#9B9B9B' }}>
              Do you want to delete project {selectedProject.name}?
            </span>
            <div className="mb-6 font-bold float-right mr-8 w-2/3">
              <div className="w-1/3" />
              <div className="w-2/3 lg:flex sm:block">
                <button
                  type="submit"
                  className="mt-1 lg:mt-0 lg:w-max w-auto border px-8 py-4 rounded-3xl text-xs mr-2 focus:outline-none flex justify-center items-center h-7"
                  onClick={() => {
                    setOnClose(false);
                  }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="mt-1 lg:mt-0 w-auto lg:w-max border px-8 py-4 rounded-3xl text-xs font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white"
                  onClick={handleDelete}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {openCreate && (
        <CreateOrganization
          handleClose={toggleOpenCreate}
          action={action}
          notification={createNotification}
          selectedProject={selectedProject.id}
          refreshList={() => refreshList()}
        />
      )}

      <div
        className="m-8 fixed bg-white"
        style={{
          filter: openCreate && 'blur(2px)',
          boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.25)',
          left: '14%',
          right: '14%',
          width: '81%',
          borderRadius: '6px',
          height: '94vh',
        }}
      >
        <div className="z-50" style={{ height: '22vh', paddingBottom: '4vh' }}>
          <div
            className="lg:flex block sm:block justify-between text-center lg:text-left w-tableWidth m-auto "
            style={{ paddingTop: '4vh' }}
          >
            <span className="text-textBlue1 font-bold text-lg">Projects</span>

            <div className="block lg:flex mt-1 lg:mt-0">
              <button
                type="submit"
                className="mt-1 lg:mt-0 w-full lg:w-max border px-3 py-1 rounded-md text-xs ml-3 font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white"
                onClick={() => {
                  downloadExcel('tblData');
                }}
              >
                Report
                <img src="assets/img/download.svg" className="h-3 ml-2 transform rotate-180" alt="" />
              </button>
              <button
                className="mt-1 lg:mt-0 w-full lg:w-max border px-3 py-1 rounded-md text-xs mx-3 font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white"
                onClick={() => {
                  setAction('create');
                  toggleOpenCreate();
                }}
              >
                Create New
                <img src="assets/img/Create.svg" className="h-2 ml-2 " alt="" />
              </button>

              <div className="mt-1 lg:mt-0 w-full text-xs lg:w-max border bg-transparent px-3 rounded-sm ml-3 flex justify-between items-center rounded-xl">
                <input
                  type="text"
                  placeholder="Search"
                  autoComplete="off"
                  className="text-textBox bg-transparent focus:outline-none"
                  value={formData.q}
                  name="q"
                  onChange={handleInputChange}
                  style={{ borderColor: '#e6e6e6' }}
                  onKeyDown={(e) => {
                    if (e.which === 13) searchData();
                  }}
                />
                <img src="assets/img/Search.png" onClick={searchData} className="h-4 ml-2 " alt="" />
              </div>
            </div>
          </div>
        </div>

        <div className="tbl" style={{ minWidth: '700px' }}>
          <div className="bg-white w-tableWidth m-auto mb-3">
            <div className="bg-white w-full flex border" style={{ borderColor: '#e6e6e6' }}>
              <div className="px-8 py-2 flex w-full relative bg-primary text-white">
                <div className=" py-2.5 text-left text-xs w-1/3 font-bold">PROJECT</div>
                <div className=" py-2.5 text-left text-xs w-1/3 font-bold">LOCATION</div>
                <div className=" py-2.5 text-left text-xs w-1/4 font-bold">LAST MODIFIED</div>
                <div className=" py-2.5 text-center text-xs w-1/5 font-bold">ACTIONS</div>
              </div>
            </div>
            {!isLoading ? (
              <div className="hideScroll" style={{ overflowY: 'scroll', height: '68vh' }}>
                <table id="tblData" className="w-full">
                  {organizations.map((item) => (
                    <tr
                      key={item?.id}
                      className="my-1 px-8 flex
                   relative hover:border-indigo-200 focus-within:border-indigo-200"
                      style={{ border: '0.5px solid #C0C0C0', boxSizing: 'border-box', borderRadius: '4px' }}
                    >
                      <td className="text-role py-2 text-left  overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-1/3">
                        {item?.projectName}
                      </td>
                      <td className="text-role py-2 text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-1/3">
                        {item?.sourceAddress?.city}, {item?.sourceAddress?.country}
                      </td>
                      <td className="text-role py-2 text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-1/4">
                        {getTimeoffset(item?.destinationAddress?.updatedAt)}
                      </td>

                      <td className="flex text-role py-2 text-center justify-center items-center overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-1/5">
                        <img
                          src="assets/img/Edit2.svg"
                          className="h-3 mr-4 "
                          alt=""
                          onClick={() => {
                            selectProject({ id: item?.id });
                            setAction('update');
                            toggleOpenCreate();
                          }}
                        />
                        <img
                          src="assets/img/Delete2.svg"
                          className="h-3"
                          alt=""
                          onClick={() => {
                            selectProject({ id: item?.id, name: item?.projectName });
                            setOnClose(true);
                          }}
                        />
                      </td>
                    </tr>
                  ))}
                </table>
              </div>
            ) : (
              <img src="assets/img/loader.svg" className="w-18 mx-auto my-16" alt="" />
            )}

            {!searchFlag && <Pagination className="Pagination" count={pageCount} page={page} onChange={handleChange} variant="outlined" shape="rounded" />}
          </div>
        </div>
      </div>
    </>
  );
}

export default Table;
